import { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import { SlickArrowLeft, SlickArrowRight, SlickProps } from '../../lib/Slick';
import Slider from 'react-slick';
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import Api from 'utils/api/Api';


export const UserBookPopular = () => {
    const { school } = useParams();
    const [infinite, setInfinite] = useState(false);

    const {data:userBookBest, isError } = useQuery({
        queryKey:['userbook','best'],
        queryFn:()=>Api.get('/api/userBook/best'),
        staleTime:1000 * 60 * 3,
        placeholderData:keepPreviousData,
        initialData:{ data:new Array(4).fill({id:-1, image:'', subject:'불러오는중...'}) },
        initialDataUpdatedAt:0,

    });

    // 창크기와 보여줄 작품의 수에 따라서 무한스크롤 여부를 결정
    const updateResize = useCallback(()=>{
        let infiniteScrollItemCount  = 5;

        if(window.innerWidth < 500) {
            infiniteScrollItemCount = 1;
        }else if(window.innerWidth < 700) {
            infiniteScrollItemCount = 2;
        }else if(window.innerWidth < 1000) {
            infiniteScrollItemCount = 3;
        }else if(window.innerWidth < 1200) {
            infiniteScrollItemCount = 4;
        }

        setInfinite(userBookBest?.data?.length < infiniteScrollItemCount);
    }, [userBookBest]);

    //창크기 변화를 감지
    useEffect(() => {        
        window.addEventListener("resize", updateResize);
      return () => {
        window.removeEventListener("resize", updateResize);
      };
    }, [updateResize]);

    
    

    const list = useMemo(() => {
        return userBookBest?.data?.map((userBook, key) => {
            const toPath = (userBook.id===-1)?'':`/view/${userBook.id}`;
            return (
                <Link className="userbook" to={`/${school}/userbook${toPath}`} key={userBook.id}>
                    <div>
                        <div className="cover">
                            { userBook.image && <img src={userBook.image} alt={userBook.subject} />}
                            { !userBook.image && <img src={`${process.env.PUBLIC_URL}/static/images/userbook/userbook_cover_no_image.jpg`} alt="표지 없음" />}
                            <div className="etc">
                                {userBook.creative === "Y" && <div className="ribbon creative"> <span>창작</span> </div>}
                            </div>
                        </div>
                        <h5 className="title"> <i className="fas fa-solid fa-crown"></i>  {userBook.subject}  </h5>
                        <div className="writer"><div className="in_writer"><strong className="userName">{userBook.userName}</strong> 작가님</div></div>
                    </div>
                </Link>
            )
        });
    }, [userBookBest, school]);

    if(isError)return null;
    return (
        <div className="bestContainer inner">
            <div className="userbookBest">
                <div className="bestTitle"><label className="label blue">BEST</label><span>인기작품</span></div>
                <Slider className="userbook_wrap slider_wrap popular_list" {...SlickProps}
                    slidesToShow={5} slidesToScroll={5} dots={false}
                    autoplay={true}
                    prevArrow={<SlickArrowLeft cn="prev_btn _blue" />}
                    nextArrow={<SlickArrowRight cn="next_btn _blue" />}
                    infinite={infinite}
                    responsive={
                        [{ breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                        { breakpoint: 1000, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                        { breakpoint: 700, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                        { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } }]}
                >
                    {list}
                </Slider>
            </div>
        </div>
    )
}